import PropTypes from 'prop-types'
import React, { useState } from "react"
import {
  Card,
  CardBody,
} from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

// actions
import { getProfile } from '../../store/auth/profile/actions';
import Table from './Table';
import Loader from "../../components/Loader";

const RetreatPage = props => {
  const [loading, setLoading] = useState(false);
  const [path] = useState("bank");

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Retreat" />
        <Card>
          <CardBody>
            <Table
              role={"Retreat"}
              path={path}
              user={props?.user}
              history={props.history}
              setLoading={setLoading}
            />
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

RetreatPage.propTypes = {
  getProfile: PropTypes.func,
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, { getProfile })(RetreatPage)
)
